import * as React from "react";

interface PopupItemParams {
    text: string;
    filterTerms?: string[];
}
const _highlight_text = (text, terms) => maxkir.highlight_text(text, terms, 'start');

const PopupItemText = ({text, filterTerms}: PopupItemParams) => {
    let txt = text;
    if (filterTerms.length) {
        txt = _highlight_text(txt, filterTerms);
    }

    return <span className='searchEverywhere__text' dangerouslySetInnerHTML={{__html: txt}}/>;
};

export default PopupItemText;